import * as React from 'react';
import { observer } from 'mobx-react';
import { FieldState } from 'formstate';
import ContractDropdownItem from 'components/ContractDropdownItem';
import { languageStore, userStore } from 'stores';
import { DropdownOptionInterface } from 'components/Forms/Dropdown';

interface Props {
    fieldState: FieldState<any>,
    editMode?: boolean,
    label: string,
    id: string,
    beforeChange?: Function,
    skipIds?: Array<string>
}

@observer class SelectUser extends React.Component<Props> {

    componentDidMount() {
        userStore.getUsers(true);
    }

    render() {
        const { fieldState, editMode, label, id, beforeChange, skipIds } = this.props;

        let availUsers: Array<DropdownOptionInterface> = [];
        userStore.users.forEach((user) => {
            if (skipIds?.includes(user.id)) return;
            
            availUsers.push({
                value: user.id,
                name: user.fullName
            })
        })

        return (
            <ContractDropdownItem
                label={label}
                id={id}
                placeholderText={languageStore.get('selectUser')}
                fieldState={fieldState}
                options={availUsers}
                beforeChange={beforeChange}
                editMode={editMode} />
        )
    }

}

export default SelectUser;